import { UiElement } from "../../ui/UiElement.js";

/**
 * Pagination helper class for paging of popup metadata
 */
export class PopupPagination extends UiElement {

    class_ = ["popup-pagination"];
    html_ = `
        <a href="#" class="btn-previous"><i class="fas fa-backward"></i> previous</a>
        <a href="#" class="btn-next">next <i class="fas fa-forward"></i></a>
        <div class="page-count-overlay">
            <div class="page-count"></div>
        </div>
    `;

    pages_ = 1;
    page_ = 1;

    constructor(target, options) {

        options = Object.assign({
            pageCount: 10,
            page: 1
        }, options || {});

        super(target, {
            "change": [],
            "next": [],
            "previous": []
        });

        this.setHtml(this.html_);
        this.setClass(this.class_);

        this.setPageCount(options.pageCount);
        this.setPage(options.page);

        this.query(".btn-previous").addEventListener("click", e => {
            e.preventDefault();
            this.previous()
        });
        this.query(".btn-next").addEventListener("click", e => {
            e.preventDefault();
            this.next();
        });
    }


    setPageCount(pages) {
        if (pages < 1) return;
        this.pages_ = pages;
        this.setPage((this.page_ > this.pages_) ? 1 : this.page_);
    }

    setPage(page) {
        // reduce by 1 to start counting at 0 for modulo
        --page;
        page = ((page % this.pages_) + this.pages_) % this.pages_;
        ++page;

        this.query(".page-count").innerText = page + " / " + this.pages_;
        if (this.page_ != page) {
            this.page_ = page;
            this.fire("change", this.page_);
        }
    }

    next() {
        this.setPage(this.page_ + 1);
        this.fire("next", this.page_);
    }

    previous() {
        this.setPage(this.page_ - 1);
        this.fire("previous", this.page_);
    }

    getPage() {
        return this.page_;
    }
}